import { Component,  OnInit, Input, Output, OnChanges, EventEmitter, Injectable,ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { User } from '../../user/model/user';
import { UserDetail } from '../../user/model/user-detail';
import { SharedService } from '../../../component/shared/shared.service';
import { UserService } from '../../user/service/user.service';
import { Appointment, Schedule } from '../../appointment/model/appointment';
import { AppointmentService } from '../../appointment/service/appointment.service';
import { Clinic } from '../../master/model/clinic';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { Service } from '../../master/model/service';
import { ServiceMasterService } from '../../master/services/service-master.service';
import { Patient } from '../../patient/model/patient';
import { PatientService } from '../../patient/service/patient-service.service';
@Component({
  selector: 'app-add-appointment',
  templateUrl: './add-appointment.component.html',
  styleUrls: ['./add-appointment.component.css']
})
export class AddPatientAppointmentComponent implements OnInit {
   @Input() patientdata : Patient ;
  Userloading : boolean;
  schedulrloading : boolean = false;
  Users : UserDetail[] = null;
  message : string = '';
  usrData: UserDetail  ;
  clinics : any;
  color:string = 'doc-list hoverList';
  defaultStyle:string = 'doc-list outList';
  hoveredDivId :number;
  appointment : Appointment ;
  appointmentData :Appointment[]; 
  patients : Patient[];
  patientList : Patient[];
  patient : Patient;
  schedules : Appointment[];
  isErrorMessage : boolean;
  appDate: any ;
  services : Service[];
  isSuccessMessage : boolean = false;
  isLoadedFromOther = false;
  isNew: boolean = false;
  patientName : string="";
  private searchTerms = new Subject<string>();  
  public ClientName = '';  
  public flag: boolean = true;
 
  myDatePickerOptions: IMyDpOptions = {
      // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  constructor(public _sharedService: SharedService, public _usrService : UserService, public _appService : AppointmentService,  public _srvService : ServiceMasterService, public _ptService : PatientService) {
    let dt = new Date();
    this.appDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
    this.appointment  =  new  Appointment(null,null,'',null,'',null,'',null,'','',null,'','','',null,'',false,'',false,'','','','','',false,false,'',0.0);
    _sharedService.yesEmitted$.subscribe(
      text => {
          if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'DOCTOR SCHEDULE') {
              //this.deleteScheduleData();
          } else {
              //this.selectedScheduleObject = {};
          }
      });
   }
  getService(id: number) {
    this._srvService.getServiceDetail(id).subscribe(data => {
         this.services = data;
    }, error => {
     
    })
  }
  ngOnInit() {
 
      this.getUsers(null);
   
    if(this.patientdata !== undefined && this.patientdata !== null) {
      this.getPatient(this.patientdata.PatientId);
    } else {
      this.getPatient(null);
    }

    this.getService(0);
 
    document.body.addEventListener('click', function(){
      if( document.getElementById('search-result') != null) {
        document.getElementById('search-result').className = "search-result-close";
      }
     
   })
  }
  ngAfterViewChecked() {
    
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  onDateChanged(event: IMyDateModel) {
    //debugger;
    
    if(event.date != null && event.date.year != 0) {
      let date = event.date.year + '/' + event.date.month + '/'+ event.date.day;
     
      if(this.appointment.AppointmentDoctorId !== undefined && this.appointment.AppointmentDoctorId !== null && this.appointment.AppointmentDoctorId !== 0){
        this.schedulrloading = true;
        this.showScheduleDate(date);
      }
      
    }
    else {
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
  }
  getScheduleForDay() {
    this.schedules = [];
   
   
    if(this.appDate === null) {
      this.message = 'Please select appointment date!'; 
      this.isErrorMessage = true;
      return;
    }
   
    this.schedulrloading = true;
    var d = this.appDate.date.day;
    if(d.toString().length==1){
      d = '0'+ this.appDate.date.day;
    }
    var m = this.appDate.date.month;
    if(m.toString().length==1){
      m = '0'+ this.appDate.date.month;
    }
    let date = this.appDate.date.year + '/' + m + '/'+ d;
    this.schedulrloading = true;
    this.showScheduleDate(date);
  }
  showScheduleDate(date : string) {
    if(!this.isLoadedFromOther){
      this.appointment.AppointmentSlotId = null;
    } else {
      if(this.appointment.AppointmentDoctorId != null) {
        this.isLoadedFromOther = false;
      }
     
    }
    if(this.appointment.AppointmentDoctorId != null) {
        this._appService.getDoctorScheduleForDay(this.appointment.AppointmentDoctorId, this.appointment.AppointmentClinicId, date).subscribe(
          data => { 
            /*this.schedules = data.filter(function(slot){
                return (slot.AppointmentIsCancelled == true || slot.AppointmentIsBooked === false) && slot.AppointmentIsScheduledActive === true
            });*/
            this.schedules = data.filter(function(slot){
              return (slot.AppointmentIsCancelled == true || slot.AppointmentIsBooked === false) 
            });
            this.schedulrloading = false;
            this.message = ""; 
          },
          error => {  this.schedulrloading = false;}
      );
    }
  }
  showClinic() {
    let docId = this.appointment.AppointmentDoctorId.toString();
    var data = this.Users.filter(function(user){
      return (user.UserId === parseInt(docId));
    })
    if(data.length>0){
      this.clinics = data[0].UserClinic;
      if(this.clinics.length>0) {
        this.appointment.AppointmentClinicId = this.clinics[0].AssociateClinicId;
        this.getScheduleForDay() ;
      }
    } 

    
  }
  getUsers(id : number) : void {
    this.Userloading = true;
    this._usrService.getUsersDetail().subscribe( data=> {
     
      this.Users = data;//.filter((usr) => usr.UserRoleId < 3 )
      if(id != undefined && id != null){
          var data = this.Users.filter(function(user){
            return (user.UserId === id);
          })
          if(data.length>0){
            this.usrData = data[0];
            this.hoveredDivId = this.usrData.UserId;
            this.appointment.AppointmentDoctorId = this.usrData.UserId;
            this.showClinic();
          } 

      } else {
        var data = this.Users.filter(function(user){
          return (user.UserId === 53);
        })
        if(data.length>0){
          this.usrData = data[0];
          this.hoveredDivId = this.usrData.UserId;
          this.appointment.AppointmentDoctorId = this.usrData.UserId;
          this.showClinic();
        }
      }
      this.Userloading = false;
    },
    error=>{
        this.Userloading = false;
        this.message = error.data;
    });
  }
  getPatient(id : number) : void {
    this.Userloading = true;
   // if(sessionStorage.getItem("data") == undefined) {
    if(id != undefined && id != null) {
      this._ptService.getPatientDetail(id).subscribe( data=> {
        
          //this.patients  = data;
         // sessionStorage.data = JSON.stringify(this.patients);

          
             // var data = this.patients.filter(function(user){
              //  return (user.PatientId === id);
             // })
              if(data.length>0){
                this.patient = data[0];
                this.ClientName = this.patient.PatientFirstName + ' '+ this.patient.PatientLastName + '-'+ this.patient.Patient_PIN ;   
                this.patientName =    this.ClientName; 
                
               this.flag = false;  
                this.appointment.AppointmentPatientId = this.patient.PatientId;
              }

         
          this.patients = [];
          this.Userloading = false;
        },
        error=>{
            this.Userloading = false;
            this.message = error.data;
        });
    } else {
      /*this._ptService.getPatientForSearch('All', '').subscribe( data=> {
        this.patientList = data;
        if(this.patientList.length>0) {
          this.flag = true; 
          document.getElementById('search-result').className = "search-result search-result-open";
        }
        this.patients = [];
        
      },
      error=>{
          
      });*/
    }
          
  }
  searchClient(term: string): void {  
    
    this.flag = false;  
    if(term.length>2 && this.isNew===false) {
      //if(sessionStorage.getItem("data") == undefined) {
        this._ptService.getPatientForSearch('All', term.toUpperCase()).subscribe( data=> {
            this.patientList = data;
            if(this.patientList.length>0) {
              this.flag = true; 
              document.getElementById('search-result').className = "search-result search-result-open";
            }
            this.patients = [];
            
          },
          error=>{
              
          });
      /*} else {
        this.patients = JSON.parse(sessionStorage.getItem("data"));
   
        this.patientList = this.patients.filter((user)=>(user.PatientFirstName.toUpperCase()+ ' ' +user.PatientLastName.toUpperCase()).replace(/\s/g,'').indexOf( term.toUpperCase().replace(/\s/g,'') )>-1|| user.PatientLastName.toUpperCase().indexOf( term.toUpperCase() )>-1 || user.PatientEmailAddress.toUpperCase().indexOf( term.toUpperCase() )>-1|| user.PatientPrimaryMobNo.toString().toUpperCase().indexOf( term.toUpperCase() )>-1 || user.Patient_PIN.toUpperCase().indexOf( term.toUpperCase() )>-1)
        if(this.patientList.length>0) {
          this.flag = true; 
          document.getElementById('search-result').className = "search-result search-result-open";
        }
        this.patients = [];
      }*/
    }
   
  }  
  setDefault(evt) {
    evt.stopPropagation();
  }
  onselectClient(ClientObj) {     
    if(ClientObj !== null) {
      if (ClientObj.AppointmentPatientId != 0) {  
        this.ClientName = ClientObj.PatientFirstName + ' '+ ClientObj.PatientLastName + '-'+ ClientObj.Patient_PIN  
        this.patientName =    this.ClientName; 
        this.appointment.AppointmentPatientId = ClientObj.PatientId;
        this.flag = false;  
      }  
      else {  
        this.flag = false;  
      }  
    }  else {
      this.isNew = true;
      this.flag = false; 
    }
  } 
  saveAppointment(): void {
    if(this.appointment.AppointmentDoctorId === null) {
      this.message = 'Please select Expert!'; 
      this.isErrorMessage = true;
      return;
    }
    if(this.appointment.AppointmentClinicId === null) {
      this.message = 'Please select clinic!'; 
      this.isErrorMessage = true;
      return;
    }
    if(this.appointment.AppointmentSlotId === null) {
      this.message = 'Please select time slot!'; 
      this.isErrorMessage = true;
      return;
    }
    /*if(this.appointment.AppointmentPatientId === null) {
      this.message = 'Please select patient!'; 
      this.isErrorMessage = true;
      return;
    }*/
    if(this.appointment.AppointmentServiceId === null) {
      this.message = 'Please select service!'; 
      this.isErrorMessage = true;
      return;
    } 
    this.Userloading = true;
    if(this.appointment.AppointmentPatientId !== null) {
        let patientId = this.appointment.AppointmentPatientId.toString();
        if(this.patientList !== undefined && this.patientList.length>0) {
            var data = this.patientList.filter(function(user){
              return (user.PatientId === parseInt(patientId));
          })
          if(data.length>0){
            this.appointment.AppointmentPatientName = data[0].PatientFirstName + ' ' + data[0].PatientLastName;
            this.appointment.AppointmentPatientMail = data[0].PatientEmailAddress;
            this.appointment.AppointmentPatientContactNo = data[0].PatientPrimaryMobNo;
          } 
        } else {
            this.appointment.AppointmentPatientName = this.patient.PatientFirstName + ' ' + this.patient.PatientLastName;
            this.appointment.AppointmentPatientMail = this.patient.PatientEmailAddress;
            this.appointment.AppointmentPatientContactNo = this.patient.PatientPrimaryMobNo;
        }
    } else {
        this.appointment.AppointmentPatientName = this.patientName;
        this.appointment.AppointmentPatientMail = "";
        this.appointment.AppointmentPatientContactNo = 0;
    }
    this.patients = [];
    var slotId  =  this.appointment.AppointmentSlotId.toString();
    let slotData = this.schedules.filter(function(user){
      return (user.AppointmentSlotId === parseInt(slotId));
   })
   if(slotData.length>0){
      this.appointment.AppointmentTime = slotData[0].AppointmentSlotDescription;
    }
    var srvId  =  this.appointment.AppointmentServiceId.toString();
    let serviceData = this.services.filter(function(user){
      return (user.ServiceId === parseInt(srvId));
   })
   if(serviceData.length>0){
      this.appointment.AppointmentServiceName = serviceData[0].ServiceName;
    }
    var d = this.appDate.date.day.toString();
    if(d.toString().length==1){
      d = '0'+ this.appDate.date.day.toString();
    }
    var m = this.appDate.date.month.toString();
    if(m.toString().length==1){
      m = '0'+ this.appDate.date.month.toString();
    }
    let date = this.appDate.date.year + '-' + m + '-'+ d;
    this.appointment.AppointmentDay = date;
    this._appService.appointmentData = this.appointment;
     this._appService.saveAppointment().subscribe(
       data => {
         this.message = "Appointment saved successfully!";
        this.isSuccessMessage = true;
        this.isErrorMessage = false;
          this.Userloading = false;
          this.hideMessage();
          //this.clear();
       },
       erorr => {
        this.message = erorr.data;
        this.isSuccessMessage = false;
        this.isErrorMessage = true;
        this.Userloading = false;
       }
      );
  };
  hideMessage() : void {
    setTimeout(() => {
      this.isErrorMessage  = false;
      this.isSuccessMessage  = false;   
      this.message = '';
       
    }, 3000);
  }
  clear() : void {
    this.appointment.AppointmentDoctorId = null;
    this.appointment.AppointmentClinicId = null;
    this.appointment.AppointmentServiceId = null;
    this.appointment.AppointmentPatientId = null;
    this.appointment.AppointmentSlotId = null;
    this.isNew = false;
    let dt = new Date();
    this.appDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
    var d = this.appDate.date.day.toString();
    if(d.toString().length == 1){
      d = '0'+ this.appDate.date.day.toString();
    }
    var m = this.appDate.date.month.toString();
    if(m.toString().length == 1){
      m = '0'+ this.appDate.date.month.toString();
    }
    let date = this.appDate.date.year + '/' + m + '/'+ d;
    this.appointment.AppointmentDay = date;
    
  }
}
 


// WEBPACK FOOTER //
// ./src/app/section/patient/add-appointment/add-appointment.component.ts